/**
 * The name to show for this server.
 *
 * A customer can set a label after the machine exists. Until they do, the
 * hostname is the name. The hostname on the machine is a separate thing.
 */
export function serverTitle(instance: { hostname: string; label?: string | null }): string {
  const label = typeof instance.label === 'string' ? instance.label.trim() : '';
  return label !== '' ? label : instance.hostname;
}

/** Where a list row or sidebar entry should land for this machine. */
export function serverPath(instance: { id: number | string; state: string }): string {
  const id = encodeURIComponent(String(instance.id));
  return instance.state === 'suspended' ? `/servers/${id}/suspended` : `/servers/${id}`;
}
